module.exports = __webpack_public_path__ + "static/educare-online-734613d16c5c880821dc68981837b122.gif";